import AccountMenu from "./AccountMenu";
import MobileAccountMenu from "./MobileAccountMenu";
import { Outlet } from "react-router-dom";

const ProfileLayout = () => {
  return (
    <>
      {/* MOBILE */}
      <MobileAccountMenu>
        <Outlet />
      </MobileAccountMenu>

      {/* DESKTOP */}
      <div className="hidden lg:block p-6">
        <div className="container mx-auto grid grid-cols-[260px_1fr] gap-6">
          <AccountMenu />
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default ProfileLayout;
